import React, { useEffect, useState } from "react";
import "./styles/style-ind.css";
import "./styles/style-international.css";

// India
import IndSectionOne from "./india-pricing/parts/section-one";
import IndSectionTwo from "./india-pricing/parts/section-two";
import IndSectionThree from "./india-pricing/parts/section-three";
import IndSectionFour from "./india-pricing/parts/section-four";
import IndSectionFive from "./india-pricing/parts/section-five";
import IndSectionSix from "./india-pricing/parts/section-six";

// International
import IntlSectionOne from "./international-pricing/parts/section-one";
import IntlSectionTwo from "./international-pricing/parts/section-two";
import IntlSectionThree from "./international-pricing/parts/section-three";
import IntlSectionFour from "./international-pricing/parts/section-four";
import IntlSectionFive from "./international-pricing/parts/section-five";
import IntlSectionSix from "./international-pricing/parts/section-six";
import { API_BASE_URL } from "@utils/constant";

const PricingIndex = () => {
    const [country, setCountry] = useState(null);

    useEffect(() => {
        fetch(API_BASE_URL + "findCountry")
            .then((res) => res.json())
            .then((data) => {
                if (data?.status === "ok") {
                    setCountry(data.data.country);
                }
            })
            .catch((err) => {
                console.error("Error fetching country:", err);
                setCountry("Other"); // fallback
            });
    }, []);

    if (!country) {
        return <div>Loading...</div>; // loader until country fetched
    }

    const isIndia = country.toLowerCase() === "india";

    return (
        <div style={{ height: "100vh" }}>
            {isIndia ? (
                <>
                    <IndSectionOne />
                    <IndSectionTwo />
                    <IndSectionThree />
                    <IndSectionFour />
                    <IndSectionFive />
                    <IndSectionSix />
                </>
            ) : (
                <>
                    <IntlSectionOne />
                    <IntlSectionTwo />
                    <IntlSectionThree />
                    <IntlSectionFour />
                    <IntlSectionFive />
                    <IntlSectionSix />
                </>
            )}
        </div>
    );
};

export default PricingIndex;
